import WalkthroughModalContainer from "./WalkthroughModalContainer";

export default WalkthroughModalContainer;
